import { getDeviceIdFromLocalStorage } from '../../utils/getlb-user-id'
import { quinceOrderAggregatorServiceHttpClient, sandServicesHttpClient } from '../../utils/HttpClient'

import { OrdersType, SearchType } from './orderAggregatorService.types'

class OrderAggregatorService {
  async getAllSearchTypes(): Promise<{ searchTypes: SearchType[] }> {
    const { data } = await quinceOrderAggregatorServiceHttpClient.get<{ searchTypes: SearchType[] }>(
      `orders/v1/find-my-order/search-types`,
    )
    return data
  }

  async getSearchResults(payload: any): Promise<OrdersType> {
    const deviceId = getDeviceIdFromLocalStorage()
    const { data } = await quinceOrderAggregatorServiceHttpClient.post<{ searchTypes: SearchType[] }>(
      `orders/v1/find-my-order`,
      payload,
      {
        headers: {
          'x-device-id': deviceId,
        },
      },
    )
    return data
  }

  async getWebsiteProducts(productIds: (number | string)[]): Promise<any> {
    const { data } = await sandServicesHttpClient.get<{ searchTypes: SearchType[] }>(`/products/enrich`, {
      params: {
        isChildProduct: true,
        internalProductIds: productIds.join(','),
        isRetiredRequired: true,
        useLite: true,
        isNewWebsite: true,
        overrideClientExclusivity: true, // should always be true for else the product will not be returned which are app exclusive
      },
    })
    return data
  }
}

const orderAggregatorService = new OrderAggregatorService()

export default orderAggregatorService
